<template>
  <div class="info-health-detail">
    <BoardDetail
      v-if="healthDetail"
      :board-id="id"
      :board="healthDetail"
      list-path="/information/health"
    />
  </div>
</template>

<script>
import BoardDetail from "@/components/BoardDetail.vue";
import { fetchHealthInfoDetail } from '@/api';

export default {
  name: 'HealthDetail',
  components: {
    BoardDetail
  },
  props: {
    id: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      healthDetail: null,
      loading: false,
      error: null
    };
  },
  async created() {
    await this.loadHealthDetail();
  },
  methods: {
    async loadHealthDetail() {
      this.loading = true;
      this.error = null;

      try {
        const response = await fetchHealthInfoDetail(this.id);
        const health = response.data;

        // 이미지 파일 확장자 정의
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
        const images = [];

        if (health.attachments && health.attachments.length > 0) {
          const sorted = health.attachments.slice().sort((a, b) => {
            const oa = a.order != null ? Number(a.order) : 0;
            const ob = b.order != null ? Number(b.order) : 0;
            return oa - ob;
          });
          sorted.forEach(att => {
            if (att.type === 'editor' || att.type === 'main') {
              return;
            }
            const ext = att.originalname ?
              att.originalname.substring(att.originalname.lastIndexOf('.')).toLowerCase() : '';

            if (!imageExtensions.includes(ext)) {
              return;
            }

            // 본문(contents)에 이미 삽입된 이미지는 중복 노출 방지
            if (att.filename && (health.contents || '').indexOf(att.filename) !== -1) {
              return;
            }
            if (att.download_url && (health.contents || '').indexOf(att.download_url) !== -1) {
              return;
            }

            images.push(att.download_url);
          });
        }

        this.healthDetail = {
          id: health.id,
          type: health.type,
          title: health.title,
          contents: health.contents || health.url,
          images: images,
          mod_dttm: health.mod_dttm,
          created_dttm: health.created_dttm,
          attachments: health.attachments || []
        };

      } catch (error) {
        this.error = '데이터를 불러오는 중 오류가 발생했습니다.';
        console.error('===== API 호출 에러 =====');
        console.error('에러:', error);
        console.error('에러 상세:', error.response?.data || error.message);
        console.error('========================');
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.info-health-detail {
  width: 100%;
  min-height: 55px;
}
</style>
